// Co-located copy of `~/utils/getWebPImageUrlWithWidth` (used by RR7 atlas). This copy is
// co-located so the shared component pulls no host `~/` import; the logic is identical.
export function getWebPImageUrlWithWidth(url: string, width: number) {
  try {
    const u = new URL(url);
    u.searchParams.set('fm', 'webp');
    u.searchParams.set('w', String(width));
    return u.toString();
  } catch {
    // If url is relative or invalid, fallback to manual append
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}fm=webp&w=${width}`;
  }
}
